import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'OCORRENCIA_TIPO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('ocorrenciaTipoForm', registro)
    ];
}

export function getLista() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/ocorrenciaTipo`)
		.then(resp => {
			dispatch({
		        type: 'OCORRENCIA_TIPO_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/ocorrenciaTipo`, {
				...registro,
				percentual_desconto: FormatUtils.formatarValorBanco(registro.percentual_desconto, 2),
				data_inicio: DateFormat.formatarDataTelaParaSql(registro.data_inicio),
				data_fim: DateFormat.formatarDataTelaParaSql(registro.data_fim),
				perfis: registro.perfis || [],
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/ocorrenciaTipo`, {
				...registro,
				percentual_desconto: FormatUtils.formatarValorBanco(registro.percentual_desconto, 2),
				data_inicio: DateFormat.formatarDataTelaParaSql(registro.data_inicio),
				data_fim: DateFormat.formatarDataTelaParaSql(registro.data_fim),
				perfis: registro.perfis || [],
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/ocorrenciaTipo?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaPerfil() {
    const request = axios.get(`${consts.API_URL}/usuarioPerfil/listarSelect`);
    return {
        type: 'OCORRENCIA_TIPO_PERFIL_SELECT_LISTADO',
        payload: request
    };
}

export function getListaCategoria() {
    const request = axios.get(`${consts.API_URL}/ocorrenciaCategoria/listarSelect`);
    return {
        type: 'OCORRENCIA_TIPO_CATEGORIA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaClasse() {
    const request = axios.get(`${consts.API_URL}/ocorrenciaClasse/listarSelect`);
    return {
        type: 'OCORRENCIA_TIPO_CLASSE_SELECT_LISTADO',
        payload: request
    };
}
